import { SortOrder } from "../sort-order";

export class CepRuleFilters {
  nameComplexRule: string;
  ruleState: string;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
